import { BASE_PARAMS } from './constants';

export const createBaseEvent = (params) => ({
    ...BASE_PARAMS,
    ...params,
});
